<template>
  <div v-if="visible" class="order-contact c:row-start-center">
    <div class="order-contact-avator">
      <img :src="userInfo.avatar" alt="" />
    </div>
    <div class="order-contact-infos">
      <div class="order-contact-labels c:row-between-center">
        <span>销售顾问</span
        ><span>{{ customer.isTrueName ? "客人姓名" : "微信昵称" }}</span>
      </div>
      <div class="order-contact-names c:row-between-center">
        <span>{{ userInfo.name }}</span
        ><span>{{ customer.name }}</span>
      </div>
      <div class="order-contact-address">{{ userInfo.storeName }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    type: {
      type: String,
      default: "order", // 'create'||'order'||'share'
    },
    order: Object,
    isBaseOrder: Boolean,
  },
  computed: {
    ...mapState(["user", "customerInfo"]),
    visible() {
      if (this.isBaseOrder) return [0, 10, 70].includes(this.order.status);
      return true;
    },
    userInfo() {
      if (this.type === "order" && this.order) {
        return {
          name: this.order.caName,
          avatar: this.order.caAvatar,
          storeName: this.order.storeName,
        };
      }
      return {
        name: this.user.name,
        avatar: this.user.caAvatar,
        storeName: this.user.storeName,
      };
    },
    customer() {
      if (this.type === "order" && this.order) {
        return {
          name: this.order.customerName,
          isTrueName: false,
        };
      }
      return {
        name: this.customerInfo.nickname,
        isTrueName: this.customerInfo.isTrueName,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.order-contact {
  gap: 14/20rem;

  box-sizing: border-box;
  width: 100%;
  padding: 10/20rem 20/20rem;
  border-top: solid 1/20rem #e4e4e4;
  border-bottom: solid 1/20rem #e4e4e4;

  &-avator {
    width: 40/20rem;
    height: 40/20rem;
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 40/20rem;
      height: 40/20rem;
    }
  }

  &-infos {
    flex: 1;
    width: 0;
    height: 52/20rem;
  }

  &-labels {
    height: 15/20rem;
    line-height: 15/20rem;
    font-size: 11/20rem;
    font-weight: 400;
    letter-spacing: 0;
    color: #909090;
  }

  &-names {
    height: 17/20rem;
    margin: 4/20rem 0;
    line-height: 17/20rem;
    font-size: 12/20rem;
    font-weight: 400;
    letter-spacing: 0;
    color: #000;
  }

  &-address {
    height: 12/20rem;
    line-height: 12/20rem;
    font-size: 11/20rem;
    font-weight: 400;
    letter-spacing: 0;
    color: #909090;
  }
}
</style>
